import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  GET_APP_IDS,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import * as actions from '../../actions/sp';
import './index.scss';
import {checkSession} from "../../api/api";
import {checkOrigin, getOrigin} from "../../actions/storage";

export class DeleteSAML extends Component {
  getAppIds = () => {
    window.parent.postMessage(GET_APP_IDS, getOrigin());
  }
  deleteApp = (e) => {
    if (checkOrigin(e.origin)) {
      this.props.deleteApp(e.data);
    }
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.deleteApp);
      this.getAppIds();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.deleteApp);
  }

  render() {
    return (
        <div/>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteApp: (applicationIds) => {
      dispatch(actions.deleteApps(applicationIds));
    }
  }
};

export default connect(
    null,
    mapDispatchToProps
)(DeleteSAML);